import {useI18n} from 'i18n/I18nContext'
import {appLocaleToBcp47} from 'i18n/locales'
import {
  AttendeeCertificate,
  CertificateVariables,
} from 'organization/Event/Certification/Certificate'
import {CertificatePreview} from 'organization/Event/Certification/Preview'
import React from 'react'
import styled from 'styled-components'

export default function CertificateItem(props: {
  certificate: AttendeeCertificate
  variables: CertificateVariables
}) {
  const {certificate, variables} = props
  const {locale, t} = useI18n()
  const svgRef = React.useRef<HTMLDivElement>(null)

  const handleDownloadSVG = () => {
    if (!svgRef.current) return
    const svgElement = svgRef.current.querySelector('svg')
    if (!svgElement) return

    const svgData = new XMLSerializer().serializeToString(svgElement)
    const blob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'})
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${certificate.certificate_serial_number}.svg`
    link.click()
    URL.revokeObjectURL(url)
  }
  return (
    <Card key={certificate.id}>
      <CardPreview>
        <div style={{maxWidth: 600, padding: 5}} ref={svgRef}>
          <CertificatePreview
            template={certificate.certificate_json}
            variables={variables}
          />
        </div>
        <div className="overlay">
          <button onClick={handleDownloadSVG} className="input__btn mb-20">
            {t('attendee.certificateDownload')}
          </button>
        </div>
      </CardPreview>
      <CardBody>
        <h3> № {certificate.certificate_serial_number} </h3>
        <p>
          {t('attendee.certificateEventLabel')} {certificate.event?.name}
          <br />
          {t('attendee.certificateIssuedOn')}{' '}
          <span>
            {new Date(certificate.created_at).toLocaleDateString(
              appLocaleToBcp47(locale),
            )}
          </span>
        </p>
      </CardBody>
    </Card>
  )
}

const Card = styled.div`
  background: #f5f5f5;
  border-radius: 5px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
`

const CardPreview = styled.div`
  position: relative;
  overflow: hidden;

  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;

    a {
      background: ${({theme}) => theme?.colors?.primary || '#6366f1'};
      color: #fff;
      font-size: 0.9rem;
      font-weight: 500;
      padding: 0.6rem 1.4rem;
      border-radius: 10px;
      text-decoration: none;
      transition: background 0.3s ease;

      &:hover {
        background: ${({theme}) => theme?.colors?.primaryHover || '#4f46e5'};
      }
    }
  }

  &:hover .overlay {
    opacity: 1;
  }
`

const CardBody = styled.div`
  padding: 1.2rem 1.5rem;

  h3 {
    font-size: 1.1rem;
    font-weight: 600;
    color: ${({theme}) => theme?.colors?.textPrimary || '#222'};
    margin-bottom: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  p {
    font-size: 0.9rem;
    color: ${({theme}) => theme?.colors?.textSecondary || '#777'};
    line-height: 1.4;

    span {
      color: ${({theme}) => theme?.colors?.textPrimary || '#111'};
      font-weight: 500;
    }
  }
`
